import { Component, Signal, inject, input, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { getCmsConfigValue, getIsOpenForSale } from '@core/infrastructure/state/core.selectors';
import { ProductPublicModels } from '@features/products/product';
import { Product } from '@features/products/product/domain/models/product.models';
import { SastreButtonComponent } from '@features/products/sastre/button/sastre-button.component';
import { AnalyticsClickSourceID } from '@shared/analytics/COMMON/models/analytics-common.models';
import { ElementObserverDirective } from '@shared/directives/element-observer.directive';
import { EventProductDetails } from '@shared/product/models';

export interface SizeGuideComponentState {
    uniqueSize: boolean;
    showDiscountDisclaimer: boolean;
    product: Product;
    isBottomSheet: boolean;
}
@Component({
    selector: 'app-size-guide',
    templateUrl: './app-size-guide.component.html',
    standalone: true,
    imports: [
        ElementObserverDirective,
        SastreButtonComponent,
        TranslateModule,
    ],
})
export class SizeGuideComponent {
    protected readonly store: Store = inject(Store);

    public classSizeWrap = input<string>();

    public product$$ = input<ProductPublicModels.PublicProduct>();

    public readonly openSizeGuideClicked = output<EventProductDetails>();

    public sastreActivated$$: Signal<boolean> = this.store.selectSignal(getCmsConfigValue('sastre_activate'));

    protected readonly ANALYTICS_CLICK_SOURCE_ID_SIZE_GUIDE = AnalyticsClickSourceID.PDPOpenSizeGuide;

    public isOpenForSale$$: Signal<boolean> = this.store.selectSignal(getIsOpenForSale);

    public openSizeGuide(e: Event): void {
        e.preventDefault();
        this.openSizeGuideClicked.emit({ type: 'openSizeGuide' });
    }
}
